module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/192vSuA/media/FC-9781398480674.jpg?1692049837665",
      "alt": "This image is the cover for the book The Light of the World"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Light of the World\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Why are we destroying our world, a world without which, we cannot live? Our world is unique, it has everything in it that we need and more. It is living and breathing and moves around very slowly so that each and every part of it has day and night. It has amazing landscapes and sights which are breath-taking. Amazing wildlife, oceans and mountains, rivers and forests. Without all this the world would not exist. It is a living and breathing planet which must be protected! We cannot continue to take what we want without considering the consequences. We must love it and care for it, and put back what we have taken. We must work together regardless of where we live, regardless of race, religion, or colour. We are in danger of upsetting the balance of the world and destroying it. We have had a warning and a pandemic! These poems look at the natural world in a new way.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Begley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane Begley is passionate about the natural world and how we must strive to protect it in every way we can. She believes we must take time to reconnect to nature and ourselves, to be ourselves and appreciate the world as a whole! If we put down our phones and computers sometimes and just listen and look at the world, we will be happier with ourselves and enjoy life more. Jane Begley enjoys writing poems about the world and life and this is her third book. Her poems are written in a unique style which makes them easy to read and understand.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0